<template >
    <div class="myCheck">
        <div :class="checked ? ['checkBox', 'checked'] : 'checkBox'" @click='handleClick($event, dataItem)'></div>
        <p class="label">{{ dataItem.label }}</p>
    </div>
</template>

<script>
export default {
    methods: {
        handleClick: function (e, data) {
            this.$emit('checkedData', data)
        }
    },
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        dataItem: {
            type: Object,
            default: {}
        }
    }

}
</script>

<style lang="scss" scoped>
.myCheck {
    display: flex;
    align-items: center;
    margin: 10px 0;

    .checkBox {
        width: 10px;
        height: 10px;
        border: 2px solid rgba(225, 225, 225, 1);
        display: inline-block;
        line-height: 200%;
        background: #fff;
        transition: all 0.4s;
        margin-right: 8px;
        cursor: pointer;
    }

    .checkBox.checked {
        background: #2E79D0;
    }

    .label {
        font-size: 12px;
        // font-weight: 600
    }
}
</style>
